function buildQuery(params = {}) {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value != null && value !== "") search.set(key, String(value));
  }
  const q = search.toString();
  return q ? `?${q}` : "";
}

async function requestJson(path, options = {}) {
  const res = await fetch(path, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || `Request failed (${res.status})`);
  }
  return data;
}

export async function fetchNewPriceBaselines(params = {}) {
  return requestJson(`/api/admin/mobility/new-vehicle-price-baselines${buildQuery(params)}`);
}

export async function fetchNewPriceBaseline(id) {
  return requestJson(`/api/admin/mobility/new-vehicle-price-baselines/${encodeURIComponent(id)}`);
}

export async function createNewPriceBaseline(body) {
  return requestJson("/api/admin/mobility/new-vehicle-price-baselines", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function updateNewPriceBaseline(id, body) {
  return requestJson(`/api/admin/mobility/new-vehicle-price-baselines/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export async function markNewPriceBaselineCurrent(id) {
  return requestJson(
    `/api/admin/mobility/new-vehicle-price-baselines/${encodeURIComponent(id)}/mark-current`,
    { method: "POST" }
  );
}

export async function expireNewPriceBaseline(id) {
  return requestJson(
    `/api/admin/mobility/new-vehicle-price-baselines/${encodeURIComponent(id)}/expire`,
    { method: "POST" }
  );
}

export async function recalculateAllNewPriceMatches(params = {}) {
  return requestJson(
    `/api/admin/mobility/new-vehicle-price-baselines/recalculate-used-matches${buildQuery(params)}`,
    { method: "POST" }
  );
}

export async function recalculateBaselineNewPriceMatches(id) {
  return requestJson(
    `/api/admin/mobility/new-vehicle-price-baselines/${encodeURIComponent(id)}/recalculate-used-matches`,
    { method: "POST" }
  );
}

export async function fetchNewVsUsedAnalytics(params = {}) {
  return requestJson(`/api/mobility/vehicle-market/analytics/new-vs-used${buildQuery(params)}`);
}
